module.exports = __webpack_public_path__ + "img/address.09f6fc94.png";